import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/arab-hardware/pages/Home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/basic/pages/Home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/black-and-white/pages/Home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/farah-omar/pages/Home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/modern/pages/Home.tsx");
